<template>
  <form class="shopping-cart-promo-form">
    <app-input
      :id="'promo'"
      v-model="code"
      class="shopping-cart-promo-form__input"
      :placeholder="''"
      :accessibility-label="'promo code'"
    >
      <span v-if="error" role="alert" class="shopping-cart-promo-form__error">
        {{ error }}
      </span>
    </app-input>
    <app-button
      class="shopping-cart-promo-form__apply m-l-10"
      :is-disabled="code.length === 0"
      :text="'Apply'"
      :aria-label="'Apply'"
      outlined-rectangle
      :handler="applyPromo"
    />
  </form>
</template>

<script>
import { OAPI_API_TYPE } from "@/utils";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PromoCodeInputCustom",
  data() {
    return {
      code: "",
      error: ""
    };
  },
  computed: {
    ...mapGetters({
      APIType: "venueSettings/APIType",
      OAPICartDiscountTags: "cart/getOAPICartDiscountsTags"
    })
  },
  methods: {
    ...mapActions({
      applyPromoCode: "cart/applyPromoCode"
    }),
    async applyPromo() {
      try {
        await this.applyPromoCode(this.code);

        if (this.APIType === OAPI_API_TYPE && !this.OAPICartDiscountTags?.includes(this.code)) {
          this.error = `Promo code ${this.code} could not be applied`;
          return;
        }

        this.error = "";
        this.code = "";
      } catch (reject) {
        this.error = reject.message;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.shopping-cart-promo-form {
  display: flex;
  justify-content: space-between;

  &__input {
    width: 74%;
  }

  &__error {
    font-size: 12px;
    color: $error-color;
  }

  &__apply {
    width: 24%;
    height: 46px !important;
  }
}

@include respond-to-mobile {
  .shopping-cart-promo-form {
    &__input {
    }

    &__apply {
    }
  }
}
</style>
